import { Component, OnInit } from '@angular/core';

import { Cerca } from "../shared/cerca.model";
import { cercaModuleName } from "../shared/data.service";
import { CercaApiService } from "../shared/cerca-api.service";
import { CercaNavigationService } from "../shared/cerca-navigation.service";
import { CercaService } from "../shared/cerca.service";
import { UtilService } from "../../../shared/services/util.service";
import {rastreamentosModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";
import {RastreamentoService} from "../../shared/rastreamento.service";

@Component({
    template: require('./cerca-list.component.html'),
    styles: [require('./cerca-list.component.css')]
})
export class CercaListComponent implements OnInit {
    list: Cerca[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    cercasModuleName: any = cercaModuleName;
    module: any = rastreamentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _cercasApiService: CercaApiService,
        private _cercasService: CercaService,
        private _cercaNavigationService: CercaNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._cercasService.clearSessionStorage();
        this._cercaNavigationService.goToNew();
    }

    clickEdit(item: Cerca) {
        this._cercasService.clearSessionStorage();
        this._cercaNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    clickDelete(item: Cerca) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._cercasApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._cercasApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/cerca-list/cerca-list.component.ts
 **/